import { client as apolloClient } from 'src/shared/graphql';
import { JobThreeDFiles } from 'src/shared/graphql/generated';
import { queries } from 'src/shared/graphql/requests';

const fetchUrls = async (jobId: number) => {
  const job = await queries.getJob(apolloClient, { id: jobId });
  const threeDFiles: JobThreeDFiles =
    job.data.jobs.results[0]?.threeDFiles || {};

  return threeDFiles;
};

export { fetchUrls };
